module.exports = __webpack_public_path__ + "assets/img/568b64c49ee6a37e7d21458f4b8bf0c8.svg";